<template>
  <div class="patient-load">
      <div class="shine-line"></div>
      <img :src="patientSkeleton" />
      
  </div>
</template>

<script>
import patientSkeleton from './image/patient-skeleton.png'
export default {
    name: 'loading-patient',

    data() {
        return {
            patientSkeleton: patientSkeleton
        }
    }
}
</script>

<style scoped>
.patient-load {
    height: calc(100vh - 50px);
    overflow-y: hidden;
}
img {
    max-width: 100%;
    position: relative;
}
.shine-line {
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(90deg, #eeeeee 0px, #ffffff 200px, #eeeeee 400px);
    opacity: 0.6;
    top: 0;
    animation: shine-line 0.8s infinite linear;
}
@keyframes shine-line {
  0% {
    background-position: 0;
  }
  100% {
    background-position: 1500px;
  }
}
</style>
